/**
 * Copies text to clipboard and shows a success toast notification
 * @param text - The text to copy to clipboard
 * @param showSuccessToast - Function to show success toast (from useToast hook)
 * @param customMessage - Optional custom success message (defaults to "Copied to clipboard!")
 */
export const copyToClipboard = async (
  text: string,
  showSuccessToast: (message: string, options?: { duration?: number }) => void,
  customMessage?: string
): Promise<void> => {
  try {
    await navigator.clipboard.writeText(text);
    showSuccessToast(customMessage || 'Copied to clipboard!', { duration: 3000 });
  } catch (error) {
    // Fallback for older browsers or when clipboard API is not available
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      showSuccessToast(customMessage || 'Copied to clipboard!', { duration: 2000 });
    } catch (fallbackError) {
      console.error('Failed to copy text to clipboard:', fallbackError);
      // Could potentially show an error toast here, but for now we'll just log it
    } finally {
      document.body.removeChild(textArea);
    }
  }
};
